import { Box, ButtonBase, Typography, useTheme } from "@mui/material";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import OtpInput from "react-otp-input";

const cacheltr = createCache({
  key: "muiltr",
  stylisPlugins: [],
});

function BalootOTPInput({ sx = [], ...props }) {
  const { otp, setOtp } = props;
  const theme = useTheme();

  return (
    <Box
      sx={[
        {
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <CacheProvider value={cacheltr}>
        <Box sx={{ direction: "ltr" }}>
          <OtpInput
            value={otp}
            onChange={(otp) => setOtp(otp)}
            numInputs={5}
            isInputNum
            placeholder="-----"
            containerStyle="baloot-otp-input"
            inputStyle={{
              width: 58,
              height: 58,
              fontFamily: "vazirMedium",
              fontSize: "24px",
              margin: "0px 4px",
              borderRadius: "8px",
              border: `1px solid ${theme.palette.grey[2]}`,
            }}
          />
        </Box>
      </CacheProvider>
    </Box>
  );
}

export default BalootOTPInput;
